import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DateInput, NumberInput, DropdownInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { checkDateSet } from "data/lib/dates"

import { FormError_s } from "styles/form-styles"
import { SingleRowCarouselState_s, MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const OverageTiered = (props: {rowData: [], defaults: object, field: string, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyStatic = {
    amtType: _.get(props, "defaults.salesAmtType"),
  }

  const emptyRecord = {
    percent: null,
    threshold: null,
  }

  const [data, setData] = useState<object|null>(props.rowData[props.field])
  const [items, setItems] = useState<Item_t[]>(initialItems && initialItems.length ? initialItems.map((item, i) => { return {...item, i }}) : [{...emptyRecord, i: 0}]);

  function updateData(val:any, field:string|string[]):void {
    let newData = _.cloneDeep(data || {})

    _.set(newData, field, val)
    if(newData.state !== 'detailed') _.set(newData, 'state', 'detailed')
    if(!newData.items) _.set(newData, 'items', [])

    delete newData.percent

    setData(newData)
    props.persist(newData, props.field, props.rowData)
  }

  function updateVal(val:any, field:string|string[]):void {
    let newData = _.cloneDeep(data || {})

    if(items[field[0]][field[1]] === val) return
    items[field[0]][field[1]] = val

    const strippedItems = items.map(({i, ...rest}) => rest)
    _.set(newData, 'items', strippedItems)
    if (newData.state !== 'detailed') _.set(newData, 'state', 'detailed')

    delete newData.percent

    setData(newData)
    props.persist(newData, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let newData = _.cloneDeep(data);
    const strippedItems = items.map(({i, ...rest}) => rest)
    _.set(newData, 'items', strippedItems);
    if (newData.state !== 'detailed') _.set(newData, 'state', 'detailed');
    props.persist(newData, 'overagedetail', props.rowData);
  }

  let renderItems = _.sortBy(items, 'i');
  const params = {
    data: items,
    persist: updateVal
  }

  useEffect(() => {
    if(_.get(props, 'rowData.overagedetail.state') !== 'detailed'){
      setData(emptyStatic)
      setItems([{...emptyRecord, i: 0}]);
    }
  }, [props['rowData']])

  const attrs = (field) => field_attrs('rentroll', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amount Type</label>
          <DropdownInput
            field="amtType"
            className="automated"
            data={data}
            attrs={attrs}
            default={props.defaults['salesAmtType']}
            options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr']}
            persist={updateData}
          />
        </div>
      </SingleRowCarouselState_s>
      <br/>
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row">
            <div style={{width: '158px'}}>
              { i === 0 && <label>Percent</label> }
              <NumberInput className="automated" attrs={attrs} field={[`${row['i']}`, 'percent']} {...params} readPrecision={4} writePrecision={4} trailingZeros={false}/>
            </div>
            <div style={{width: '158px'}}>
              { i === 0 && <label>Threshold</label> }
              <NumberInput className="automated" attrs={attrs} field={[`${row['i']}`, 'threshold']} {...params} readPrecision={4} writePrecision={4} trailingZeros={false}/>
            </div>
            <RowAddRemove emptyRecord={emptyRecord} setState={updateItems} row={i} items={items} />
          </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default OverageTiered
